import { WorldPayResponse } from '@dgx-pr-spa/shared/util';
import { ActionError } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const loadWorldPay = createAction('[Complete Order] Load WorldPay');

export const loadWorldPaySuccess = createAction(
  '[Complete Order] Load WorldPay Success',
  props<{ payload: WorldPayResponse }>()
);

export const loadWorldPayFail = createAction(
  '[Complete Order] Load WorldPay Fail',
  props<{ payload: ActionError }>()
);

export const resetWorldPay = createAction('[Complete Order] Reset WorldPay');

export type WorldPayActions =
  | typeof loadWorldPay
  | typeof loadWorldPaySuccess
  | typeof loadWorldPayFail
  | typeof resetWorldPay;
